import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { isFacebookSDKLoadedAtom } from "../atoms/isFacebookSDKLoadedAtom";
import { QUERY_KEYS } from "../constants/queryKeys";

export const useGetFacebookLoginStatus = () => {
  const isFacebookSDKLoaded = useAtomValue(isFacebookSDKLoadedAtom);

  return useQuery({
    queryKey: [QUERY_KEYS.GET_FACEBOOK_LOGIN_STATUS],
    queryFn: getFacebookLoginStatus,
    enabled: isFacebookSDKLoaded ? undefined : false,
  });
};

const getFacebookLoginStatus: () => Promise<fb.AuthResponse | null> = () => {
  return new Promise((res) => {
    FB.getLoginStatus((loginStatusResponse) => {
      if (loginStatusResponse.status === "connected") {
        return res(loginStatusResponse.authResponse);
      } else {
        return res(null);
      }
    });
  });
};
